import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ConfigService } from '@fcom/core';

import { TransactionsResponse } from '../interfaces';

@Injectable()
export class CampaignService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  enrollToCampaign(campaignId: string, mni: string): Observable<any> {
    const apiUrl = this.configService.cfg.loyaltyServices.legacy.apiUrl;

    const payload = {
      campaignId,
      mni,
    };

    return this.http.post<TransactionsResponse>(`${apiUrl}/campaigns/enroll`, payload);
  }
}
